
import { Loader2 } from "lucide-react";
import { TableCell, TableRow } from "@/components/ui/table";

interface UsersTableStatusProps {
  loading: boolean;
  isEmpty: boolean;
}

export function UsersTableStatus({ loading, isEmpty }: UsersTableStatusProps) {
  if (loading) {
    return (
      <TableRow>
        <TableCell colSpan={4} className="text-center py-12">
          <div className="flex justify-center">
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
          </div>
          <p className="mt-2 text-sm text-muted-foreground">Carregando usuários...</p>
        </TableCell>
      </TableRow>
    );
  }

  if (isEmpty) {
    return (
      <TableRow>
        <TableCell colSpan={4} className="text-center py-12">
          <p className="text-sm text-muted-foreground">Nenhum usuário encontrado.</p>
        </TableCell>
      </TableRow>
    );
  }

  return null;
}
